var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcExpandM = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "7itene35ka",
    d: "M13.825 7.158L10 10.975 6.175 7.158 5 8.333 10 13.333 15 8.333z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-965 -294) translate(385 284) translate(580 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ddkihemerb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7itene35ka"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#ddkihemerb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcExpandM, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-expand-m.65d3342e.svg";
export { ForwardRef as ReactComponent };